import fetch from "@lib/fetch";
import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";

import { cacheKey } from "./constants";
import type { LinkAliasMarkupDataResponse, PostLinkAliasMarkupProps } from "./types";

export const postLinkAliasMarkup = reactQueryMutationAdapter(
  cacheKey,
  async (linkAliasMarkupData: PostLinkAliasMarkupProps): Promise<LinkAliasMarkupDataResponse> => {
    return fetch(cacheKey, "POST", linkAliasMarkupData);
  }
);
